// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OdQl","icon":"styles_icon__3dEL0"};